

interface ThreePillarsModelSectionProps {
	dictionary: any;
}

export function ThreePillarsModelSection({ dictionary }: ThreePillarsModelSectionProps) {
  const pillars = [
    {
      number: "1",
      title: "Familia",
      description: "Involucramos activamente a la familia en el proceso terapéutico, brindando orientación, estrategias y capacitación para dar continuidad al tratamiento en el hogar.",
      color: "neuro-red"
    },
    {
      number: "2",
      title: "Escuela",
      description: "Coordinamos con centros educativos para implementar adaptaciones necesarias, ofreciendo seguimiento y capacitación a docentes para apoyar el aprendizaje.",
      color: "neuro-yellow"
    },
    {
      number: "3",
      title: "Profesionales",
      description: "Trabajamos en equipos multidisciplinarios de forma coordinada, compartiendo objetivos y estrategias para asegurar un tratamiento integral.",
      color: "neuro-green"
    }
  ]

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'neuro-red':
        return 'border-neuro-red bg-neuro-red bg-opacity-20 text-neuro-red'
      case 'neuro-yellow':
        return 'border-neuro-yellow bg-neuro-yellow bg-opacity-20 text-neuro-yellow'
      case 'neuro-blue':
        return 'border-neuro-blue bg-neuro-blue bg-opacity-20 text-neuro-blue'
      case 'neuro-green':
        return 'border-neuro-green bg-neuro-green bg-opacity-20 text-neuro-green'
      default:
        return 'border-neuro-blue bg-neuro-blue bg-opacity-20 text-neuro-blue'
    }
  }

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-neuro-blue opacity-5 rounded-full hidden md:block"></div>
      <div className="absolute bottom-10 left-10 w-40 h-40 bg-neuro-red opacity-5 rounded-full hidden md:block"></div>
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-neuro-dark-blue mb-6">
            {dictionary.homepage?.threePillarsModel?.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {dictionary.homepage?.threePillarsModel?.subtitle}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
          {pillars.map((pillar, index) => {
            const colorClasses = getColorClasses(pillar.color)
            const borderColor = `border-t-4 ${colorClasses.split(' ')[0]}`
            return (
              <div key={index} className={`bg-white rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105 ${borderColor}`}>
                <h3 className="text-2xl font-bold text-neuro-dark-blue mb-4 flex items-center">
                  <span className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 font-bold text-xl ${colorClasses.split(' ').slice(1).join(' ')}`}>
                    {pillar.number}
                  </span>
                  {pillar.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            )
          })}
        </div>
        
        <div className="mt-16 text-center">
          <a 
            href="/quienes-somos" 
            className="inline-block bg-neuro-dark-blue text-white py-4 px-10 rounded-full hover:bg-neuro-blue transition-colors text-lg font-semibold"
          >
            {dictionary.common?.learnMore}
          </a>
        </div>
      </div>
    </section>
  )
}
